import React from 'react';
import { Check } from 'lucide-react';
import { Button } from './Button';
import { CHECKOUT_URL, finalIncludedItems } from '../data/offer';
import { trackCheckout } from '../utils/tracking';
const noMore = ['No more hours searching for your next drill', 'No more disconnected training ideas', 'No more repeating the same session because planning time ran out', 'No more wondering what progression should come next', 'No more treating striking, clinch, takedowns and ground work as disconnected phases', 'No more starting every class from an empty page'];
export function FinalCTA() {
  return <section className="py-24 px-4 bg-black relative overflow-hidden border-t border-zinc-800" data-id="element-86" data-mp="vv1crr89uecc">
      <div className="max-w-4xl mx-auto relative z-10" data-id="element-87" data-mp="qvf0bk09p24l">
        <div className="text-center mb-16" data-id="element-88" data-mp="qy16bf7if9kp">
          <h2 className="text-3xl md:text-5xl font-black uppercase mb-8 leading-tight text-white" data-id="element-89" data-mp="14uobu6dj3828">
            Next week, you can keep building every session from scratch...
          </h2>
          <p className="text-xl md:text-2xl font-display font-extrabold text-amber-400 mb-10" data-id="element-90" data-mp="2c56hmm3ph1ru">
            Or you can open a complete 6-in-1 visual coaching system and already know where to
            start.
          </p>
          <div className="max-w-2xl mx-auto text-left space-y-4 mb-12 bg-zinc-900 p-8 rounded-2xl border border-zinc-800" data-id="element-91" data-mp="2m21cmv0rsk1d">
            {noMore.map(item => <div key={item} className="flex items-start gap-3" data-id="element-92" data-mp="2v3sefos6w6py">
                <span className="text-red-500 mt-0.5" aria-hidden="true" data-id="element-93" data-mp="2v1g2bs944qkt">▸</span>
                <span className="text-zinc-300" data-id="element-94" data-mp="30111o3s730y2">{item}</span>
              </div>)}
          </div>
          <p className="text-xl text-white mb-3" data-id="element-95" data-mp="34u3uuat288dq">
            MMA Coach Ready does not replace your knowledge as a coach.
          </p>
          <p className="text-lg md:text-xl font-display font-extrabold uppercase text-zinc-300" data-id="element-96" data-mp="3errrj6a87pyj">
            It gives you a system for using that knowledge with more structure, consistency and
            efficiency.
          </p>
        </div>

        <div className="bg-zinc-900 border-2 border-amber-400/80 rounded-3xl p-8 md:p-12 shadow-2xl shadow-black/60" data-id="element-97" data-mp="1jp4rnj7tonk6">
          <h3 className="text-2xl font-black uppercase text-white mb-6 text-center border-b border-zinc-800 pb-6" data-id="element-98" data-mp="1er39d0i80s9r">
            Everything included
          </h3>
          <ul className="grid sm:grid-cols-2 md:grid-cols-3 gap-x-8 gap-y-4 mb-10" data-id="element-99" data-mp="1novtchyw0o3h">
            {finalIncludedItems.map(item => <li key={item} className="flex items-start gap-3" data-id="element-100" data-mp="22d048zrp7vbp">
                <Check size={18} className="text-amber-400 shrink-0 mt-0.5" aria-hidden="true" data-id="element-101" data-mp="1xeot8lpo3erw" />
                <span className="text-sm text-zinc-300" data-id="element-102" data-mp="2behq6yrser8b">{item}</span>
              </li>)}
          </ul>
          <div className="text-center" data-id="element-103" data-mp="27f8uvph3mlan">
            <p className="text-xl font-display font-black text-amber-400 mb-2" data-id="element-104" data-mp="h1i54q4n14tn">MMA COACH READY</p>
            <p className="text-sm text-zinc-400 mb-8 max-w-2xl mx-auto" data-id="element-105" data-mp="h3bb037ffl0l">
              150 ready-to-coach MMA sessions designed to help coaches plan less, teach with more
              structure and develop athletes from beginner to advanced.
            </p>
            <Button href={CHECKOUT_URL} onLinkClick={trackCheckout} className="w-full md:w-auto text-xl py-6 px-12 mb-6" data-id="element-106" data-mp="6w9x6vwrs84b">
              Get the complete MMA coaching system now
            </Button>
            <div className="flex flex-wrap justify-center gap-4 text-xs text-zinc-400 mb-6" data-id="element-107" data-mp="3fdms0vt75kki">
              <span className="font-bold text-amber-400" data-id="element-108" data-mp="3kcg3kioxb1i1">$27 USD</span>
              <span data-id="element-109" data-mp="3kad6jepcs83t">• Immediate Access</span>
              <span data-id="element-110" data-mp="36d821j5afhao">• Complete 6-in-1 Digital Bundle</span>
            </div>
            <p className="text-lg font-display font-black uppercase text-white" data-id="element-111" data-mp="3bbrs9vqwzf8u">
              Stop building every session from scratch.
            </p>
            <p className="text-base text-zinc-300 mt-1" data-id="element-112" data-mp="14mmwmg01fra6">
              Open the system. Choose the session. Start coaching.
            </p>
          </div>
        </div>
      </div>
    </section>;
}